import { Tag } from '@cian/components';
import * as React from 'react';

import { BuildingTypeName } from '../../../../types/commercial';
import { IBuildingTypeBuildingTag } from '../../../state/tags/definitions/building_type.building';
import { TagNew } from '../TagNew';

import { tagThemeSmall } from '../tag_theme';

export interface IBuildingTypeBuildingTagItemProps {
  tag: IBuildingTypeBuildingTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

export const BuildingTypeBuildingTagItem = ({ tag, onDeleteClick, withNewTag }: IBuildingTypeBuildingTagItemProps) => {
  const TagComponent = React.useMemo(() => (withNewTag ? TagNew : Tag), [withNewTag]);

  return (
    <TagComponent onDeleteClick={onDeleteClick} tagStyles={tagThemeSmall}>
      {BuildingTypeName.get(tag.value)}
    </TagComponent>
  );
};
